import { render, staticRenderFns } from "./ViewClaims.vue?vue&type=template&id=2a382e23&scoped=true"
import script from "./ViewClaims.vue?vue&type=script&lang=ts"
export * from "./ViewClaims.vue?vue&type=script&lang=ts"
import style0 from "./ViewClaims.vue?vue&type=style&index=0&id=2a382e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a382e23",
  null
  
)

export default component.exports